<script setup lang="ts">
import cover from "@brand-cover"

interface MobileHeaderProps {
  title: string
  imageSrc?: string
  isLoading?: boolean
}

withDefaults(defineProps<MobileHeaderProps>(), {
  imageSrc: "",
  isLoading: false,
})
</script>

<template>
  <div class="relative flex md:hidden items-center justify-center min-h-100 px-4 mb-8">
    <img v-if="imageSrc && !isLoading" :src="imageSrc" class="-z-10 absolute inset-0 bg-cover bg-center object-cover w-full h-100">
    <img v-else :src="cover" class="-z-10 absolute inset-0 bg-cover bg-center object-cover w-full h-100">
  </div>
</template>
